var map = {
	"./c-sharp.svg": 825,
	"./c.svg": 793,
	"./dart.svg": 8664,
	"./firebase.svg": 3327,
	"./flutter.svg": 1794,
	"./git.svg": 5187,
	"./godot.svg": 9492,
	"./html-5.svg": 2660,
	"./java.svg": 69,
	"./js.svg": 3032,
	"./matlab.svg": 3014,
	"./my-sql.svg": 2968,
	"./o-caml.svg": 1677,
	"./open-gl.svg": 838,
	"./php.svg": 8082,
	"./processing.svg": 9054,
	"./python.svg": 8779,
	"./question.svg": 6745,
	"./r-studio.svg": 6657,
	"./r.svg": 7127,
	"./sass.svg": 8158,
	"./unity.svg": 9495,
	"./vue-js.svg": 9317
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7714;